import { forwardRef, useEffect, useImperativeHandle, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Divider, Form, Row } from 'antd';

import { convertESTtoUTC } from '@/utils/date';

import { formFlagToBoolean } from '../../../../../../../../utilz';
import { routeFileSelector } from '../../../../../../../../utilz/i18n';
import PrimaryLabel from '../../../../../../../components/Labels/PrimaryLabel';
import OurClaimForm from './OurClaimForm';
import YourClaimForm from './YourClaimForm';

const OverChargeDetails = forwardRef(({ claimDetails }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFormData: () => form.getFieldsValue(),
    validateForm: async () => {
      try {
        await form.validateFields();
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }));

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleFormSetValue = (data) => {
    form.setFieldsValue({
      ammendmentDate: convertESTtoUTC(data?.ammendmentDate) ?? undefined,
      auditedBy: data?.auditedBy,
      bolAttach: formFlagToBoolean(data?.bolAttach),
      carrierClaimNo: data?.carrierClaimNo,
      carrierDisplayAddress: data?.carrierDisplayAddress,
      carrierEmail: data?.carrierEmail,
      carrierKey: data?.carrierKey,
      carrierName: data?.carrierName,
      checkDateToCustomer: convertESTtoUTC(data?.checkDateToCustomer) ?? undefined,
      checkNoFromCarrier: data?.checkNoFromCarrier,
      checkNoToCustomer: data?.checkNoToCustomer,
      closedDate: convertESTtoUTC(data?.closedDate) ?? undefined,
      currencyCode: data?.currencyCode,
      dateSubmitted: convertESTtoUTC(data?.dateSubmitted) ?? undefined,
      fbAttach: formFlagToBoolean(data?.fbAttach),
      invAttach: formFlagToBoolean(data?.invAttach),
      ocTypeKey: data?.ocTypeKey,
      otherAttach: formFlagToBoolean(data?.otherAttach),
      otherDesc: data?.otherDesc,
      reasonCode: data?.reasonCode,
      statusCode: data?.statusCode,
    });
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: fix
  useEffect(() => {
    if (claimDetails?.fbOcKey) {
      handleFormSetValue(claimDetails);
    }
  }, [claimDetails]);
  return (
    <div className="d-flex  py-16 h-100" style={{ flexDirection: 'column' }}>
      <Row className="px-30 align-items-center" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">{t('translation:claims.Details')}</PrimaryLabel>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <Form form={form} className="px-30">
          <OurClaimForm editMode claimDetails={claimDetails} form={form} />
          <Divider className="my-16 w-100" dashed />
          <YourClaimForm editMode claimDetails={claimDetails} form={form} />
        </Form>
      </div>
    </div>
  );
});

export default OverChargeDetails;
